import React, { Fragment } from "react";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";

import { Row, Col } from "reactstrap";

import Mixed from "../Components/Mixed";

const TransitionGraph3 = ({ graphData }) => {
  //設立数（incorporations）の値が0じゃないデータだけ抽出
  const filterdData = graphData.filter((val) => val.node.incorporations);

  //横軸
  const horizontalAxis = [];
  filterdData.map((array) => horizontalAxis.push(array.node.year));

  //設立数
  const incorporations = [];
  filterdData.map((array) => incorporations.push(array.node.incorporations));

  //グラフデータ
  const orgNumberSeries = [
    {
      name: "設立数",
      data: incorporations,
    },
  ];

  //グラフオプション
  const orgNumberOptions = {
    chart: {
      type: "bar",
      height: 350,
      stacked: true,
      toolbar: {
        show: false,
      },
      // zoom: {
      //   enabled: true,
      // },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "top",
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
        dataLabels: {
          enabled: true,
          position: "top",
        },
      },
    },
    dataLabels: {
      enabled: true,
      position: "top",
      style: {
        colors: ["#495057"],
      },
      formatter(value) {
        return value.toLocaleString();
      },
      offsetY: -22,
    },

    xaxis: {
      categories: horizontalAxis,
    },
    yaxis: {
      labels: {
        formatter(value) {
          return value.toLocaleString();
        },
      },
    },
    legend: {
      position: "right",
      offsetY: 40,
    },
    fill: {
      opacity: 1,
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
  };

  return (
    <Fragment>
      <CSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}
      >
        <Row>
          <Col
            sm="12"
            md="12"
            lg="12"
            style={{ marginTop: 50, marginBottom: 30 }}
          >
            <Mixed
              graphSeries={orgNumberSeries}
              graphOptions={orgNumberOptions}
            />
          </Col>
        </Row>
      </CSSTransitionGroup>
    </Fragment>
  );
};

export default TransitionGraph3;
